(() => {
 const script=document.querySelector('script[data-pawnello-gifts]');if(!script||window.PawnelloGifts)return;
 const config=fetch(script.dataset.config).then(r=>{if(!r.ok)throw Error("La configuración de regalos no está disponible. Inténtalo de nuevo.");return r.json();});
 const request=async(path,body)=>{const r=await fetch(path,{method:body?'POST':'GET',cache:'no-store',headers:{'Content-Type':'application/json',Accept:'application/json'},body:body?JSON.stringify(body):undefined});const data=await r.json();if(!r.ok)throw Error(data.description||"No se han podido preparar tus regalos. Inténtalo de nuevo.");return data;};
 let tail=Promise.resolve();
 const enqueue=task=>{const result=tail.then(()=>task());tail=result.catch(()=>{});return result;};
 async function reconcile(cart){
  const cfg=await config;cart=cart||await request('/cart.js');let changed=false;
  const eligible=(cfg.eligibleCurrencies||['EUR']).includes(cart.currency)&&cart.items.some(item=>cfg.productIds.includes(item.product_id));
  const updates={},add=[];
  for(const gift of cfg.gifts){
   const lines=cart.items.filter(item=>item.variant_id===gift.variantId&&item.properties?._pawnello_fountain_gift==='v1');
   if(!eligible){for(const line of lines)updates[line.key]=0;continue;}
   if(!lines.length)add.push({id:gift.variantId,quantity:1,properties:{_pawnello_fountain_gift:'v1'}});
   else lines.forEach((line,index)=>{const quantity=index===0?1:0;if(line.quantity!==quantity)updates[line.key]=quantity;});
  }
  if(Object.keys(updates).length){cart=cart=await request('/cart/update.js',{updates});changed=true;}
  if(add.length){await request('/cart/add.js',{items:add});changed=true;cart=await request('/cart.js');}
  if(eligible)for(const gift of cfg.gifts){
   const line=cart.items.find(item=>item.variant_id===gift.variantId&&item.properties?._pawnello_fountain_gift==='v1');
   if(!line||line.quantity!==1||line.final_line_price!==0)throw Error("No se han podido confirmar tus regalos gratis. Inténtalo de nuevo antes de finalizar la compra.");
  }
  return {cart,changed};
 }
 function prepare(){return enqueue(reconcile);}
 async function sections(cart){
  const ids=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))];
  cart.sections={};
  await Promise.all(ids.slice(0,5).map(async id=>{
   const url=new URL(location.href);url.searchParams.delete('sections');url.searchParams.set('section_id',id);url.searchParams.set('_cart_refresh',Date.now());
   const response=await fetch(url.pathname+url.search,{cache:'no-store'});
   if(!response.ok)throw Error("No se ha podido actualizar tu carrito. Inténtalo de nuevo.");
   const html=await response.text();
   if(!html.includes('shopify-section-'+id))throw Error("No se ha podido actualizar tu carrito. Inténtalo de nuevo.");
   cart.sections[id]=html;
  }));
  return cart;
 }
 function refresh(){return enqueue(async()=>sections((await reconcile()).cart));}
 function changeQuantity(key,quantity){return enqueue(async()=>{
  // Never use a cached line position or variant ID: gift additions reorder lines.
  let cart=await request('/cart.js');
  if(cart.items.some(item=>item.key===key)){
   const cfg=await config;
   const otherFountain=cart.items.some(item=>item.key!==key&&cfg.productIds.includes(item.product_id));
   if(quantity===0&&!otherFountain){
    const updates={[key]:0};
    cart.items.filter(item=>item.properties?._pawnello_fountain_gift==='v1').forEach(item=>{updates[item.key]=0;});
    cart=await request('/cart/update.js',{updates});
   }else cart=await request('/cart/change.js',{id:key,quantity});
  }
  return sections((await reconcile(cart)).cart);
 });}
 const showError=error=>{let box=document.getElementById('pawnello-gift-error');if(!box){box=document.createElement('p');box.id='pawnello-gift-error';box.setAttribute('role','alert');box.style.cssText='padding:16px;color:#a11919;background:#fff';(document.querySelector('main')||document.body).prepend(box);}box.textContent=error.message;};
 window.PawnelloGifts={prepare,refresh,changeQuantity};
 // Tell the native cart drawer to render the reconciled server cart. Its URL
 // may be the homepage, so refreshing only /cart leaves stale paid gift rows.
 const refreshCart=result=>{if(result.changed)document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:result.cart,sourceId:'pawnello-gifts',data:{source:'pawnello-gifts',itemCount:result.cart.item_count,sections:{}}}}));};
 document.addEventListener('cart:update',event=>{if(['pawnello-gifts','pawnello-cart-refresh'].includes(event.detail?.sourceId)||event.detail?.data?.source==='cart-items-component')return;prepare().then(refreshCart).catch(showError);});
 document.addEventListener('click',async event=>{
  const checkout=event.target.closest('a[href="/checkout"],button[name="checkout"],input[name="checkout"]');if(!checkout)return;
  event.preventDefault();event.stopImmediatePropagation();if(checkout.dataset.giftBusy==='true')return;checkout.dataset.giftBusy='true';
  try{await prepare();location.assign('/checkout');}catch(error){showError(error);}finally{delete checkout.dataset.giftBusy;}
 },true);
 if(location.pathname==='/cart')prepare().then(refreshCart).catch(showError);
})();
